export const SAVED_SELECTION = 'SavedSelection';
//# sourceMappingURL=saved-selection.js.map